import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { RulesExecutionLogsQuery } from '@rossum/api-client/rulesExecutionLogs';
import { api } from '../../../lib/apiClient';

export const QUERY_KEY_RULES_EXECUTION_LOGS = 'rules-execution-logs';

export const useRulesExecutionLogs = (query: RulesExecutionLogsQuery = {}) => {
  return useQuery({
    queryKey: [QUERY_KEY_RULES_EXECUTION_LOGS, query] as const,
    queryFn: async () => {
      const response = await api.request(
        endpoints.rulesExecutionLogs.list(query)
      );
      return response;
    },
    cacheTime: 0,
  });
};
